import { all, put, takeEvery, call } from 'redux-saga/effects';
import actions from './actions';
import { getRequest } from '../../../../helpers/axiosClient';

export function* getDashboard(params) {
    try {
        let response = yield call(() => getRequest(params.url));
        yield put({
            type: actions.SALES_DASHBOARD_SUCCESS,
            payload: response?.data
        });
    } catch (error) {
        yield put({ type: actions.SALES_DASHBOARD_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getCustomerAgedDues(params) {
    try {
        let response = yield call(() => getRequest(params.url));
        yield put({
            type: actions.CUSTOMER_AGED_DUES_SUCCESS,
            payload: response?.data
        });
    } catch (error) {
        yield put({ type: actions.CUSTOMER_AGED_DUES_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getInactiveCustomers(params) {
    try {
        let response = yield call(() => getRequest(params.url));
        yield put({
            type: actions.INACTIVE_CUSTOMERS_SUCCESS,
            payload: response?.data
        });
    } catch (error) {
        yield put({ type: actions.INACTIVE_CUSTOMERS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export default function* salesDashboardSaga() {
    yield all([
        takeEvery(actions.SALES_DASHBOARD_START, getDashboard),
        takeEvery(actions.CUSTOMER_AGED_DUES_START, getCustomerAgedDues),
        takeEvery(actions.INACTIVE_CUSTOMERS_START, getInactiveCustomers)
    ]);
}